import { get } from "svelte/store"
import { currentDictionary } from "$lib/stores/currentDictionary"


export const translations = () => {
    const dictionary = get(currentDictionary)
    return dictionary as any
}
